import React, { useEffect } from "react";
import bannerVideo from "../assets/6036842_Doctor_Paramedic_3840x2160.mp4";
import bannerImg from "../assets/Banner.png";

const Home = () => {
  useEffect(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("manualLogout");

    sessionStorage.clear();
  }, []);
  return (
    <div>
      {/* ================= BANNER ================= */}
      <div style={styles.bannerContainer}>
        <video
          src={bannerVideo}
          style={styles.bannerVideo}
          autoPlay
          loop
          muted
          playsInline
        />
      </div>

      {/* ================= BELOW BANNER SECTION ================= */}
      <div style={styles.section}>
        <div style={styles.left}>
          <h1>NanoPulse - A Leading Pathology Lab for Blood Test!</h1>

          <p style={styles.highlight}>
            We provide high-quality diagnostic services with cutting-edge technology and experienced professionals ensuring accuracy and reliability.
          </p>

          <p>
            We are proud to expand our diagnostic services with the addition of Radiology Tests. From X-rays to MRIs, experience seamless healthcare with our expert radiology services.
          </p>

          <div style={styles.list}>
            <div>✔ Safe & Hygienic standards.</div>
            <div>✔ Quick turnaround time for all major tests.</div>
            <div>✔ Tested under extreme conditions.</div>
            <div>✔ Reliable reports for better healthcare decisions.</div>
          </div>
          <div style={styles.cards}>
            <div style={styles.card}>
              <h3>Our Mission</h3>
              <p>
                To provide reliable, affordable, and timely pathology services while
                maintaining the highest standards of patient care.
              </p>
            </div>

            <div style={styles.card}>
              <h3>Our Vision</h3>
              <p>
                To become a trusted healthcare partner by delivering high-quality
                diagnostic services with accuracy and innovation.
              </p>
            </div>
          </div>
        </div>

        <div style={styles.right}>
          <img src={bannerImg} alt="banner" style={styles.image} />

        </div>
      </div>

      {/* ================= POPULAR TEST BOX ================= */}
      <div style={styles.popularWrapper}>
        <div style={styles.popularHeader}>Popular Tests</div>

        <div style={styles.popularContent}>
          {[
            "Pregnancy Test",
            "Full Body Checkups",
            "Covid 19 Test",
            "Heart Test",
            "Kidney Test",
            "Liver Test",
            "CBC Test",
            "Cholesterol Test",
            "HbA1c Test",
            "Hepatitis B Test",
            "Kidney Function Test",
            "Liver Function Test",
            "Sugar Test",
            "Thyroid Test",
            "Typhoid Test",
            "Uric Acid Test",
            "Vitamin B12 Test",
            "Vitamin D Test",
            "Allergy Test",
            "Arthritis Test",
            "Cancer Test",
            "Bone And Joint",
            "Dengue Test",
            "Diabetes Test",
            "Rheumatoid Test",
            "Tuberculosis Test",
            "Infertility Test",
            "Diabetes Care",
            "Anemia Test",
            "GastroIntestinal",
            "Autoimmune Disorders",
            "Fever Test"
          ].map((test, index) => (
            <span key={index} style={styles.testItem}>
              {test}
              {index !== 31 && <span style={styles.separator}>|</span>}
            </span>
          ))}
        </div>
      </div>

      {/* ================= ORGAN TEST ICONS ================= */}
      <div style={styles.organsWrapper}>
        {[
          { name: "Lungs", img: require("../assets/icons/lungs.png") },
          { name: "Kidney", img: require("../assets/icons/kidney.png") },
          { name: "CBC", img: require("../assets/icons/cbc.png") },
          { name: "Thyroid", img: require("../assets/icons/thyroid.png") },
          { name: "Allergy", img: require("../assets/icons/allergy.png") },
          { name: "Fever", img: require("../assets/icons/fever.png") }

        ].map((item, index) => (
          <div key={index} style={styles.organCard}>
            <div style={styles.organCircle}>
              <img src={item.img} alt={item.name} style={styles.organIcon} />
            </div>
            <p style={styles.organLabel}>{item.name}</p>
          </div>
        ))}
      </div>

      {/* ================= TECHNOLOGY SECTION ================= */}
      <div style={styles.techWrapper}>

        <h2 style={styles.techHeading}>Our Technology & Expertise</h2>

        <div style={styles.techGrid}>
          {[
            { title: "Molecular Diagnostic & Cytogenomics", icon: "pi pi-sitemap" },
            { title: "Flow Cytometry", icon: "pi pi-sliders-h" },
            { title: "Renal Pathology & Electron Microscopy", icon: "pi pi-search" },
            { title: "Microbiology & Infectious Molecular", icon: "pi pi-globe" },
            { title: "Histopathology & IHC", icon: "pi pi-eye" },
            { title: "Hematology & Immunology", icon: "pi pi-heart" },
            { title: "Clinical Chemistry & Biochemical Genetics", icon: "pi pi-cog" },
            { title: "Histocompatibility & Transplant Immunology", icon: "pi pi-shield" }
          ].map((item, index) => (
            <div key={index} style={styles.techCard}>
              <div style={styles.techIconBox}>
                <i className={item.icon}></i>
              </div>
              <p style={styles.techText}>{item.title}</p>
            </div>
          ))}
        </div>

      </div>

    </div>
  );
};

export default Home;
const styles = {
  bannerContainer: {
    width: "100%",
    height: "95vh",
    overflow: "hidden"
  },
  bannerVideo: {
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },

  section: {
    display: "flex",
    padding: "60px 80px",
    gap: "40px",
    backgroundColor: "#f7f7f7"
  },

  left: {
    flex: 1
  },

  right: {
    flex: 1
  },

  highlight: {
    color: "#2b6cb0",
    fontWeight: "500"
  },

  list: {
    marginTop: "20px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "10px"
  },

  image: {
    width: "100%",
    borderRadius: "8px"
  },

  cards: {
    display: "flex",
    gap: "25px",
    marginTop: "30px",
  },

  card: {
    flex: 1,
    background: "#fff",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
  },

  link: {
    color: "#2b6cb0",
    cursor: "pointer",
    fontWeight: "500"
  },
  popularWrapper: {
    marginTop: "40px"
  },

  popularHeader: {
    backgroundColor: "#1f56a3",
    color: "#fff",
    padding: "14px 40px",
    fontSize: "18px",
    fontWeight: "500",
    borderTopLeftRadius: "6px",
    borderTopRightRadius: "6px"
  },

  popularContent: {
    backgroundColor: "#fff",
    padding: "18px 40px",
    borderBottomLeftRadius: "6px",
    borderBottomRightRadius: "6px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
    lineHeight: "2.2",
  },

  testItem: {
    fontSize: "15px",
    color: "#222",
    cursor: "pointer",
  },

  separator: {
    margin: "0 8px",
    color: "#999"
  },
  /* ORGAN ICON ROW */

  organsWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "50px 8%",
    background: "#f5f5f5",
    flexWrap: "wrap"
  },

  organCard: {
    textAlign: "center",
    flex: "1",
    minWidth: "140px"
  },

  organCircle: {
    width: "130px",
    height: "130px",
    margin: "0 auto",
    borderRadius: "50%",
    background: "#eaeaea",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },

  organIcon: {
    width: "65px",
    height: "65px",
    objectFit: "contain"
  },

  organLabel: {
    marginTop: "12px",
    fontSize: "16px",
    color: "#555"
  },
  /* TECHNOLOGY SECTION */

  techWrapper: {
    padding: "60px 8%",
    background: "linear-gradient(to bottom, #e6eff7, #cfdbe6)"
  },

  techHeading: {
    fontSize: "28px",
    marginBottom: "35px",
    color: "#2f2f2f"
  },

  techGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "25px"
  },

  techCard: {
    background: "#f3f3f3",
    borderRadius: "16px",
    padding: "35px 20px",
    textAlign: "center",
    transition: "0.3s",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    cursor: "pointer"
  },

  techIconBox: {
    width: "70px",
    height: "70px",
    margin: "0 auto 15px",
    borderRadius: "50%",
    background: "#e0e7ef",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "28px",
    color: "#2f66b1"
  },

  techText: {
    fontSize: "15px",
    color: "#333",
    lineHeight: "1.5"
  },
};